import { Transition } from "@headlessui/react"
import { ReactNode, useEffect, useState } from 'react'
import * as React from 'react'
import { useTranslation } from "react-i18next"
import { useConnect } from "wagmi"

import { useDebounce } from "../../hooks"
import { useIsConnected } from "../../state/application/hooks"
import { PolymorphicRef } from "../../types"
import { ButtonProps } from "../Button"
import { Injected, MetamaskIcon, WalletConnectIcon } from "../Icons"
import { Menu } from "../Menu"


const Icons: Record<string, ReactNode> = {
  Injected: <Injected width={16} height={16} />,
  MetaMask: <MetamaskIcon width={16} height={16} />,
  WalletConnect: <WalletConnectIcon width={16} height={16} />,
}
export const ConnectButton = React.forwardRef(
  <Tag extends React.ElementType = 'button'>(
    {
      children,
      ...rest
    }: ButtonProps<Tag>,
    ref?: PolymorphicRef<Tag>
  )  => {
  const { t } = useTranslation()
  const [hover, setHover] = useState(false)
  const [debouncedHover, setDebouncedHover] = useState(false)
  const DebouncedHover = useDebounce([debouncedHover, hover], 200)
  const [, { updateConnection }] = useIsConnected()
  const { connectors, connect } = useConnect()

  useEffect(() => {
    const [debouncedHover] = DebouncedHover
    setHover(debouncedHover)
  }, [DebouncedHover])
  return (
    <Menu
      className={rest.fullWidth ? 'w-full' : ''}
      button={
        <Menu.Button
          onMouseEnter={() => {
            setHover(true)
            setDebouncedHover(true)
          }}
          onMouseLeave={() => setDebouncedHover(false)}
          {...rest}
          as="div"
        >
          {children || 'Connect Wallet'}
        </Menu.Button>
      }
    >
      <Transition show={hover}>
        <Menu.Items
          placement="top"
          className="z-[100] grid !bg-transparent -mt-1 justify-center group-one origin-top  min-w-[240px] max-h-60 py-2 gap-x-4 w-fit overflow-hidden  rounded-lg shadow-lg ring-opacity-5 focus:outline-none"
          onMouseLeave={() => setDebouncedHover(false)}
          onMouseEnter={() => {
            setDebouncedHover(true)
            setHover(true)
          }}
        >
          {connectors.map((connector) => (
            <Menu.Item
              key={connector.id}
              onClick={() => {
                connect({ connector })
                updateConnection(true)
              }}
              as="div"
              className="z-50 flex items-center w-full h-auto gap-3 hover:opacity-80 transform-all hover:bg-gray-500 group"
            >
              <div className="-ml-[6px] group-hover:bg-blue-100 rounded-full group-hover:ring-[5px] group-hover:ring-blue-100">
                {Icons[connector.name] && Icons[connector.name]}
              </div>
              {connector.name}
            </Menu.Item>
          ))}
          <Menu.Item
            as="a"
            onClick={() => {}}
            href="https://ethereum.org/wallets"
            rel="noreferrer"
            target="_blank"
            className="z-50 grid items-center justify-center w-full h-auto -mt-1 leading-none cursor-pointer text-xxxs tracking-default hover:opacity-80 hover:bg-gray-500 text-pollingactive "
          >
            {t('New to Crypto?')}
            <p className="z-50 grid font-bold cursor-pointer text-fire1 hover:opacity-50">
              {t('Learn more about wallets')}
            </p>
          </Menu.Item>
          <div className="top-0 left-0 custom-backdrop-blur z-1" />
        </Menu.Items>
      </Transition>
    </Menu>
  )
})